/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import firebase from 'firebase/app';
import {
  Box,
  Button,
  TextField,
  makeStyles,
  Modal,
  Typography,
  CircularProgress
} from '@material-ui/core';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Upload } from 'react-feather';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { v4 as uuidv4 } from 'uuid';
import countries from '../../../utils/countries';

import 'firebase/storage';

const FILE_SIZE = 160 * 1024;
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  modal: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '80%',
    overflowY: 'auto'
  },
  imageButton: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 50,
    width: 100,
    height: 100,
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f2f2f2',
    maxHeight: '80%',
    overflowY: 'auto'
  },
  image: {
    position: 'absolute',
    objectFit: 'cover',
    top: 0,
    left: 0,
    irght: 0,
    width: 98,
    height: 98,
    borderRadius: 49
  }
}));

function ImageInput(props) {
  const classes = useStyles();
  const { errorMessage, field, onBlur } = props;
  const { name } = field;
  const fileUpload = React.createRef();
  const [state, setState] = useState({
    file: undefined,
    imagePreviewUrl: undefined
  });
  const [error, seterror] = useState(errorMessage);

  React.useEffect(() => {
    seterror(errorMessage);
  }, [errorMessage]);

  function handleImageChange(e) {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    if (file) {
      reader.onload = () => {
        const image = new Image();
        image.src = reader.result;
        const { type } = file;

        if (SUPPORTED_FORMATS.includes(type)) {
          image.onload = () => {
            const ratio = image.width / image.height;
            file.aspectRatio = ratio;

            setState({
              file,
              imagePreviewUrl: reader.result
            });

            props.setFieldValue(props.field.name, file);
          };
        } else {
          props.setFieldValue(props.field.name, file);
        }
      };
      reader.readAsDataURL(file);
    }
  }

  return (
    <>
      <Button
        id={name}
        name="file"
        onClick={() => {
          fileUpload.current.value = null;
          fileUpload.current.click();
        }}
        className={classes.imageButton}
        // touched
        onBlur={onBlur}
        style={{
          borderColor: error ? 'red' : 'transparent'
        }}
      >
        {state.imagePreviewUrl ? (
          <img src={state.imagePreviewUrl} alt="" className={classes.image} />
        ) : (
          <Upload />
        )}
        <input
          // file
          // required
          hidden
          style={{
            overflow: 'hidden',
            paddingTop: '100%',
            width: 100,
            height: 100,
            borderRadius: 50,
            borderWidth: 0,
            outline: 0
          }}
          ref={fileUpload}
          label="Upload profile photo"
          // fullWidth
          onChange={handleImageChange}
          // className={classes.hidden}
          // variant="outlined"
          // id={name}
          // name={name}
          type="file"
        />
      </Button>
      {error ? (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      ) : null}
    </>
  );
}

ImageInput.propTypes = {
  errorMessage: PropTypes.string,
  setFieldValue: PropTypes.func,
  onBlur: PropTypes.func,
  field: PropTypes.object
};

const Toolbar = ({ className, refreshPages, ...rest }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValidateError, setformValidateError] = useState();

  async function uploadImageStorage(id, file) {
    // console.log(file);
    // const imagePath = file.readAsDataURL(file);
    const ext = file.name.split('.').pop();

    const uploadRef = `pages/${`${id}.${ext?.toLocaleLowerCase()}`}`;

    await firebase
      .storage()
      .ref(uploadRef)
      .put(file)
      .then((res) => {
        console.log('Item upload succes', res);
      })
      .catch((e) => {
        setLoading(false);
        throw new Error(e);
      });

    const downloadURL = firebase.storage().ref(uploadRef).getDownloadURL();

    return downloadURL;
  }

  async function createPage(values) {
    const { title, description, country, file } = values;
    setLoading(true);
    const docId = uuidv4();

    const downloadURL = await uploadImageStorage(docId, file);

    console.log('country', country);

    const _pageData = {
      title,
      description,
      countryCode: country.code,
      countryName: country.name,
      photoURL: downloadURL,
      createDate: firebase.firestore.FieldValue.serverTimestamp()
    };

    return firebase.firestore().doc(`pages/${docId}`).set(_pageData);
    // .then(() => {
    //   console.log('Success');
    // })
    // .catch((e) => {
    //   setLoading(false);
    //   console.log('Bir hata olustu', e);
    // });
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function countryToFlag(isoCode) {
    return typeof String.fromCodePoint !== 'undefined'
      ? isoCode
          .toUpperCase()
          .replace(/./g, (char) =>
            String.fromCodePoint(char.charCodeAt(0) + 127397)
          )
      : isoCode;
  }

  // const ImageInput =  ({ field, ...props }) => {
  //   return <input type="file" />;
  // };

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box display="flex" justifyContent="flex-end">
        {/* <Button className={classes.importButton}>
          Import
        </Button>
        <Button className={classes.exportButton}>
          Export
        </Button> */}
        <Button
          color="primary"
          variant="contained"
          onClick={() => handleOpen()}
        >
          Add Page
        </Button>
      </Box>
      {/* <Box mt={3}>
        <Card>
          <CardContent>
            <Box maxWidth={500}>
              <TextField
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  )
                }}
                placeholder="Search Pages"
                variant="outlined"
              />
            </Box>
          </CardContent>
        </Card>
      </Box> */}
      <Modal
        disableBackdropClick={!!loading}
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modal}>
          {formValidateError ? (
            <Box mb={2}>
              <Alert
                severity="error"
                onClose={() => setformValidateError(null)}
                className={classes.alert}
              >
                <AlertTitle>Error</AlertTitle>
                {formValidateError}
              </Alert>
            </Box>
          ) : null}
          <Formik
            initialValues={{
              file: '',
              title: '',
              description: '',
              country: countries[0].name
            }}
            validationSchema={Yup.object().shape({
              file: Yup.mixed()
                .required('Profile picture is required')
                .test(
                  'fileSize',
                  'Image is too large',
                  (value) => value && value.size <= FILE_SIZE
                )
                .test(
                  'fileFormat',
                  'Unsupported Format',
                  (value) => value && SUPPORTED_FORMATS.includes(value.type)
                )
                .test(
                  'fileAspectRatio',
                  'Please recheck the image resolution, should be square, 1:1 ratio',
                  (value) => value && value.aspectRatio === 1
                ),
              title: Yup.string().required('Title is required'),
              description: Yup.string()
                .max(300)
                .required('Description is required'),
              country: Yup.object().required('Country is required')
            })}
            onSubmit={async (values) => {
              // console.log('OKEY I AM GOING INNN, and this is values', values);
              await createPage(values)
                .then(() => {
                  refreshPages();
                  setLoading(false);
                  setOpen(false);
                })
                .catch((e) => {
                  setformValidateError(
                    `An error happend during creating page. Code: ${e}`
                  );
                  setLoading(false);
                });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={2}>
                  <Field
                    name="file"
                    component={ImageInput}
                    title="Select a file"
                    setFieldValue={setFieldValue}
                    errorMessage={errors.file ? errors.file : undefined}
                    touched={touched.file}
                    style={{ display: 'flex' }}
                    onBlur={handleBlur}
                  />
                </Box>
                <Box mb={2}>
                  <TextField
                    required
                    error={Boolean(touched.title && errors.title)}
                    fullWidth
                    helperText={touched.title && errors.title}
                    label="Title"
                    margin="normal"
                    name="title"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.title}
                    variant="outlined"
                  />
                </Box>
                <Box mb={2}>
                  <TextField
                    required
                    multiline
                    error={Boolean(touched.description && errors.description)}
                    fullWidth
                    helperText={touched.description && errors.description}
                    label="Description"
                    margin="normal"
                    name="description"
                    rows={4}
                    rowsMax={6}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.description}
                    variant="outlined"
                  />
                </Box>
                <Box mb={2}>
                  <Autocomplete
                    id="country"
                    fullWidth
                    options={countries}
                    classes={{
                      option: classes.option
                    }}
                    onChange={(e, value) => {
                      setFieldValue('country', value);
                    }}
                    autoHighlight
                    getOptionLabel={(option) => option.name}
                    renderOption={(option) => (
                      <>
                        <span style={{ marginRight: 4 }}>
                          {countryToFlag(option.code)}
                        </span>
                        {option.name} ({option.code})
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        label="Choose a country"
                        variant="outlined"
                        error={Boolean(touched.country && errors.country)}
                        helperText={touched.country && errors.country}
                        onBlur={handleBlur}
                        inputProps={{
                          ...params.inputProps
                          // autoComplete: 'new-password' // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />
                </Box>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  {isSubmitting ? <CircularProgress /> : 'Add'}
                </Button>
              </form>
            )}
          </Formik>
        </div>
      </Modal>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  refreshPages: PropTypes.func
};

export default Toolbar;
